import * as ACTION_TYPES from "../types";

let initialState = {
  commissionList: [],
  commission: {},
  loading: false,
  error: false,
  message: []
};

export default (state = initialState, action) => {
    switch (action.type) {
      case ACTION_TYPES.GET_COMMISSIONS:
      return { ...state, commissionList: action.data };

      case ACTION_TYPES.RESET_COMMİSSİON:
        return { ...state, error: false };
      case ACTION_TYPES.GET_COMMİSSİON_BY_ID:
        return { ...state, commission: action.data }
      default:
        return state;
    }
  };
